export const ADD_DOWNLOAD = "ADD_DOWNLOAD";
export const SET_DOWNLOAD_COUNT = "SET_DOWNLOAD_COUNT";
export const SET_SHOW_DOWNLOAD = "SET_SHOW_DOWNLOAD";
export const ADD_CANCEL_DOWNLOAD = "ADD_CANCEL_DOWNLOAD";
export const REMOVE_DOWNLOAD="REMOVE_DOWNLOAD";
export const UPDATE_DOWNLOAD="UPDATE_DOWNLOAD";
export const REMOVE_CANCEL_DOWNLOAD = "REMOVE_CANCEL_DOWNLOAD";
export const SHOW_CANCEL_POPUP="SHOW_CANCEL_POPUP";
export const ADD_RETRY_DOWNLOAD="ADD_RETRY_DOWNLOAD";
export const REMOVE_RETRY_DOWNLOAD="REMOVE_RETRY_DOWNLOAD";
export const REFRESH_DOWNLOAD="REFRESH_DOWNLOAD";
